import { TranslationArgs } from '../questionDefinitions/types';

declare global {
  interface Window {
    translator: any;
  }
}

const getTranslation = (props: string | TranslationArgs): string => {
  if (typeof props === 'string') {
    return window.translator.t(props);
  }

  return window.translator.t(props.label, props.options);
};

export default getTranslation;
